import {
  AfterViewInit,
  Component,
  Inject,
  NgZone,
  OnInit,
  Optional,
  ViewChild
} from '@angular/core';
import {
  MatDialogRef,
  MatSort,
  MatTableDataSource,
  MAT_DIALOG_DATA,
  Sort
} from '@angular/material';
import { DTOLiveRouteNow } from '../../../../../@core/models/DTOLiveRouteNow';
import { NewTPSL, NEW_TPSL_DATA } from '../../fake.data';

@Component({
  selector: 'crm-new-tpsl-dialog',
  templateUrl: './crm-new-tpsl-dialog.component.html',
  styleUrls: ['./crm-new-tpsl-dialog.component.scss']
})
export class CrmNewTpslDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns: string[] = [
    'RouteDate',
    'RouteId',
    'ParcelId',
    'PickupId',
    'ShipmentType',
    'ShipmentStatus',
    'InsertDate',
    'UpdateDate'
  ];

  newTPSLDatasource = new MatTableDataSource<DTOLiveRouteNow>(null);

  constructor(
    public dialogRef: MatDialogRef<CrmNewTpslDialogComponent>,
    private ngZone: NgZone,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.newTPSLDatasource = new MatTableDataSource<DTOLiveRouteNow>(
      data.StopHistory
    );
    this.newTPSLDatasource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'RouteDate':
          return new Date(item.RouteDate);
        case 'InsertDate':
          return new Date(item.InsertDate);
        case 'UpdateDate':
          return new Date(item.UpdateDate);
        default:
          return item[property];
      }
    };
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.newTPSLDatasource.sort = this.sort;
  }

  public close(): void {
    this.dialogRef.close(false);
  }
}
